import { render } from "./new-dashboard-pm.vue?vue&type=template&id=2de0ad0c&scoped=true"
import script from "./new-dashboard-pm.vue?vue&type=script&lang=js"
export * from "./new-dashboard-pm.vue?vue&type=script&lang=js"

import "./new-dashboard-pm.vue?vue&type=style&index=0&id=2de0ad0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de0ad0c"]])

export default __exports__